export var AudioType = /*#__PURE__*/ function(AudioType) {
    AudioType[AudioType["DiceRoll1"] = 0] = "DiceRoll1";
    AudioType[AudioType["DiceRoll2"] = 1] = "DiceRoll2";
    AudioType[AudioType["DiceRoll3"] = 2] = "DiceRoll3";
    AudioType[AudioType["DiceRoll4"] = 3] = "DiceRoll4";
    AudioType[AudioType["YourTurn"] = 4] = "YourTurn";
    AudioType[AudioType["FirstReminder"] = 5] = "FirstReminder";
    AudioType[AudioType["RoadPlace"] = 6] = "RoadPlace";
    AudioType[AudioType["SettlementPlace"] = 7] = "SettlementPlace";
    AudioType[AudioType["CityPlace"] = 8] = "CityPlace";
    AudioType[AudioType["ShipPlace"] = 9] = "ShipPlace";
    AudioType[AudioType["ShipMove"] = 10] = "ShipMove";
    AudioType[AudioType["MetropolisPlace"] = 11] = "MetropolisPlace";
    AudioType[AudioType["CityWallPlace"] = 12] = "CityWallPlace";
    AudioType[AudioType["CityDestroy"] = 13] = "CityDestroy";
    AudioType[AudioType["CityImprovement"] = 14] = "CityImprovement";
    AudioType[AudioType["RobberPlace"] = 15] = "RobberPlace";
    AudioType[AudioType["PiratePlace"] = 16] = "PiratePlace";
    AudioType[AudioType["LeaveRoom"] = 17] = "LeaveRoom";
    AudioType[AudioType["JoinRoom"] = 18] = "JoinRoom";
    AudioType[AudioType["RoomSettingUpdated"] = 19] = "RoomSettingUpdated";
    AudioType[AudioType["RoomGetReady"] = 20] = "RoomGetReady";
    AudioType[AudioType["ClockTick"] = 21] = "ClockTick";
    AudioType[AudioType["MessageNotification"] = 22] = "MessageNotification";
    AudioType[AudioType["Click"] = 23] = "Click";
    AudioType[AudioType["Victory"] = 24] = "Victory";
    AudioType[AudioType["VoteReminder"] = 25] = "VoteReminder";
    AudioType[AudioType["AchievementCKProgress"] = 26] = "AchievementCKProgress";
    AudioType[AudioType["GameStarted"] = 27] = "GameStarted";
    AudioType[AudioType["GameStartedGuitar"] = 28] = "GameStartedGuitar";
    AudioType[AudioType["AchievementLargestArmy"] = 29] = "AchievementLargestArmy";
    AudioType[AudioType["AchievementLongestRoad"] = 30] = "AchievementLongestRoad";
    AudioType[AudioType["SettlementPhaseEnded"] = 31] = "SettlementPhaseEnded";
    AudioType[AudioType["SettlementPhaseEndedGuitar"] = 32] = "SettlementPhaseEndedGuitar";
    AudioType[AudioType["OfferAcceptable"] = 33] = "OfferAcceptable";
    AudioType[AudioType["OfferNotAcceptable"] = 34] = "OfferNotAcceptable";
    AudioType[AudioType["OfferAccepted"] = 35] = "OfferAccepted";
    AudioType[AudioType["OfferRejected"] = 36] = "OfferRejected";
    AudioType[AudioType["Reconnect"] = 37] = "Reconnect";
    AudioType[AudioType["Disconnect"] = 38] = "Disconnect";
    AudioType[AudioType["KnightEquip"] = 39] = "KnightEquip";
    AudioType[AudioType["KnightPlace"] = 40] = "KnightPlace";
    AudioType[AudioType["KnightUpgrade"] = 41] = "KnightUpgrade";
    AudioType[AudioType["DiscardBroadcast"] = 42] = "DiscardBroadcast";
    AudioType[AudioType["DiscardNotification"] = 43] = "DiscardNotification";
    AudioType[AudioType["BeginnerHintActivated"] = 44] = "BeginnerHintActivated";
    AudioType[AudioType["DevelopmentCardBought"] = 45] = "DevelopmentCardBought";
    AudioType[AudioType["DevelopmentCardMonopoly"] = 46] = "DevelopmentCardMonopoly";
    AudioType[AudioType["DevelopmentCardUsed"] = 47] = "DevelopmentCardUsed";
    return AudioType;
}({});
